<template>
    <b-overlay :show="tableLoading" rounded="sm" >
        <b-card class="inner-block progress-status">
            <b-card-header>
                <b-row class="mt-2">
                    <b-col cols="12" class="d-flex">
                        <b-input id="search-progress-status-input" type="text" :placeholder="$translate('search_progress_status')" v-model="filter"></b-input>
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <b-col class="page-block"><strong> {{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }} {{
                    Math.ceil(rowsLength / itemsPerPage) }} {{ $translate('total') }}:
                        {{ rowsLength }}</strong></b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <div class="responsive-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th v-for="item in fields" :key="item.key">{{ item.label }}</th>
                                </tr>
                            </thead>
                            <draggable tag="tbody" @end="onDragEnd" :options="draggableOptions" class="draggable-table">
                                <!-- <tr v-if="tableLoading">
                                    <td colspan="99">
                                        <div class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                        </div>
                                    </td>
                                </tr> -->
                                <tr v-for="(item) in displayedItems" :key="item.id" class="draggable-item">
                                    <td>
                                        <b-button :id="'show-progress-status-item-'+item.id" v-if="hasPermissionView" @click="$emit('show-item', item.id)"
                                            variant="pink-button">
                                            <img src="@/assets/images/icon/view.svg" />
                                        </b-button>
                                    </td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.status_value }}</td>
                                </tr>
                            </draggable>
                        </table>
                    </div>
                </b-col>
            </b-card-body>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center mt-4" :prev-text="$translate('previous')"
                        :next-text="$translate('next')" v-model="currentPage" :total-rows="rowsLength" :per-page="itemsPerPage"
                        aria-controls="roleTable" pills align="right"></b-pagination>

                </b-col>
            </b-row>
        </b-card>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import draggable from 'vuedraggable';

export default {
    name: 'ProgressStatus-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: {
        //type, // not used

        /**
         * List of items to  be displayed in the table
         */
        items: Array,
        /**
         * The title of the table
         */
        title: String,
    },
    components: { draggable },

    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            tableLoading: false,
            currentPage: 1,
            rowsLength: this.rows,
            draggableOptions: {
                animation: 300
            },
        }
    },

    mounted() {
        this.doSearch()
    },

    methods: {
        async onDragEnd(event) {
            this.items.splice(event.newIndex, 0, this.items.splice(event.oldIndex, 1)[0]);
            this.items.forEach(function (items, index) {
                items.order = index;
            });
            const progressStatusItems = this.items
            await this.$store.dispatch('progressStatus/updateProgressStatusOrder', { progressStatusItems })
            this.doToast(
                this.$translate('success'),
                this.$translate(`progress_status_sequence`),
                'success'
            )

        },
       async doSearch() {
            this.tableLoading = true
            await this.$store.dispatch('progressStatus/fetchAll')
        },
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = 'Delete Type?'
            const message = `${this.$translate('delete_note')} ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('progressStatus/delete', id)
                        .then(() => {
                            this.doToast(
                                this.$translate('deleted'),
                                this.$translate('item_delete_alert'),
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                }
            })
        },
    },
    watch: {
        filteredItems: {
            immediate: true,
            handler: function (val) {
                this.rowsLength = val.length
            }
        },
        progress_statuses: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$translate('name') },
                { key: 'status_value', label: this.$translate('status_value') },
            ]
        },
        filteredItems() {
            if (this.filter) {
                const lowerFilter = this.filter.toLowerCase();
                const filteredItem = this.items.filter(item =>
                    item.name.toLowerCase().includes(lowerFilter) ||
                    item.description.toLowerCase().includes(lowerFilter)
                );
                return filteredItem
            } else {
                return this.items;
            }
        },
        displayedItems() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.filteredItems.slice(startIndex, endIndex);
        },
        progress_statuses() {
            const progressStatuses =
                this.$store.state.progressStatus.progress_statuses

                || []
            return progressStatuses
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        }
    },
}
</script>
<style></style>
